var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClip(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1725 4.99772L5.58651 11.5837C5.39549 11.7682 5.24312 11.9889 5.13831 12.2329C5.03349 12.4769 4.97831 12.7394 4.97601 13.0049C4.9737 13.2705 5.0243 13.5338 5.12486 13.7796C5.22543 14.0254 5.37393 14.2487 5.56172 14.4365C5.7495 14.6243 5.97281 14.7728 6.2186 14.8734C6.46439 14.9739 6.72775 15.0245 6.99331 15.0222C7.25887 15.0199 7.52131 14.9647 7.76532 14.8599C8.00932 14.7551 8.23001 14.6027 8.41451 14.4117L14.8285 7.82572C15.5571 7.07131 15.9603 6.0609 15.9512 5.01212C15.9421 3.96333 15.5214 2.96008 14.7798 2.21845C14.0381 1.47682 13.0349 1.05614 11.9861 1.04703C10.9373 1.03791 9.92692 1.44109 9.17251 2.16972L2.75751 8.75472C1.63219 9.88004 1 11.4063 1 12.9977C1 14.5892 1.63219 16.1154 2.75751 17.2407C3.88282 18.366 5.40907 18.9982 7.00051 18.9982C8.59194 18.9982 10.1182 18.366 11.2435 17.2407L17.5005 10.9977",
    stroke: "#B0AEB4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClip);
export default __webpack_public_path__ + "static/media/clip.4c48b5767e33ad3ad6b13393e1c94543.svg";
export { ForwardRef as ReactComponent };